module.exports = __webpack_public_path__ + "img/Small-Horizontal-Rectangular-Attachment-22.dafc9c53.png";